var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-container",attrs:{"id":"logLayout"}},[_c('Menu',{attrs:{"menuName":_vm.menuName}}),_c('Topbar',{ref:"topbar",attrs:{"menuName":_vm.menuName}}),_c('div',{staticClass:"contents-container",class:_vm.isLoading ? 'loading' : ''},[_c('router-view',{ref:"router",class:_vm.isLoading ? 'blur' : ''})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }